import ClinicDetails, {getServerSideProps} from "@page-containers/locations/clinic-details";

export {getServerSideProps};

export default ClinicDetails;
